var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "kioskBox",
    class: {
      fullScreen: _vm.pipsListFullScreen,
      notShowFootBar: !_vm.State.showFootBar
    },
    attrs: {
      "id": "kioskModule"
    }
  }, [_c('div', {
    staticClass: "contentBox",
    class: {
      showChat: _vm.State.showChatMessage
    }
  }, [_c('div', {
    staticClass: "hide",
    staticStyle: {
      "position": "absolute"
    }
  }, [_vm._v(_vm._s(_vm.allRtilList))]), _c('div', {
    staticClass: "hide"
  }, [_vm._v(_vm._s(_vm.allRtilList) + "," + _vm._s(_vm.behaviorInfo) + "," + _vm._s(_vm.shareList) + ", " + _vm._s(_vm.outputRtilCode))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.pipsListFullScreen,
      expression: "!pipsListFullScreen"
    }],
    staticClass: "vfbBox"
  }, [_c('header', {
    staticClass: "head"
  }, [_vm.userInfo.rtilCode && !_vm.userInfo.globalControl ? _c('OutputSelect', {
    attrs: {
      "partyInfo": _vm.userInfo,
      "partyCode": _vm.partyCode
    }
  }) : _vm._e(), _vm.userInfo.rtilCode ? _c('MainWindowSelect', {
    ref: "mainWindowSelect",
    attrs: {
      "partyCode": _vm.partyCode,
      "shareRtilCode": _vm.shareRtilCode,
      "currentTypeShare": _vm.shareScreenType,
      "partyInfo": _vm.userInfo,
      "nickNameInfo": _vm.behaviorInfo,
      "shareList": _vm.shareList,
      "globalOutputTimestamp": _vm.globalOutputTimestamp,
      "partyOutputTimestamp": _vm.partyOutputTimestamp,
      "mainWindowList": _vm.mainWindowList
    },
    on: {
      "callback": _vm.mainwindowSelectCallback
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "pipListBox",
    class: {
      showChat: _vm.State.showChatMessage
    }
  }, [_c('div', {
    ref: "pipBox",
    staticClass: "pipList",
    class: {
      fullScreen: _vm.pipsListFullScreen,
      notShowFootBar: !_vm.State.showFootBar,
      showLogoConfig: _vm.showUploadLogo,
      onlyMainWindow: _vm.allRtilList.length == 1
    }
  }, [_vm.showUploadLogo ? _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "el-icon-back pointer",
    on: {
      "click": _vm.hideUplogo
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('kioskHost.addBack')))])]) : _vm._e(), _vm.showUploadLogo ? _c('PictureLeftAside', {
    ref: "leftAside",
    attrs: {
      "firstLogoList": _vm.firstLogoList
    },
    on: {
      "setBgImg": _vm.setBgImg,
      "callBack": _vm.setInitBackground
    }
  }) : _vm._e(), _c('participateList', {
    ref: "participantList",
    attrs: {
      "shareList": _vm.shareList,
      "currentTypeShare": _vm.shareScreenType,
      "rtilList": _vm.allRtilList,
      "behaviorInfo": _vm.behaviorInfo,
      "streamInfo": _vm.channels,
      "outputRtilCode": _vm.outputRtilCode,
      "outputRtilList": _vm.outputRtilList,
      "packagedDeviceType": _vm.deviceTypeMap,
      "anywherePopShow": _vm.anywhereSettingShowMap,
      "userInfo": _vm.userInfo,
      "devicePlatform": _vm.devicePlatform,
      "deviceType": _vm.deviceType,
      "degreeHost": _vm.degreeHost,
      "isAudioLevel": _vm.isAudioLevel,
      "fullScreen": _vm.pipsListFullScreen,
      "uploadLogo": _vm.showUploadLogo,
      "outputSourceType": _vm.outputSourceType,
      "tagNameInfo": _vm.tagNameInfo,
      "showChatMessage": _vm.State.showChatMessage,
      "rtc": _vm.rtc,
      "host": "host",
      "extraChannel": _vm.extraChannel,
      "allRList": _vm.allRList,
      "remoteNetWorks": _vm.remoteNetWorks
    },
    on: {
      "callback": _vm.attendCallback
    },
    scopedSlots: _vm._u([{
      key: "rightBox",
      fn: function () {
        return [_c('PictureRightAside', {
          ref: "rightAside",
          attrs: {
            "initLogoList": _vm.initLogoList,
            "firstLogoList": _vm.firstLogoList
          },
          on: {
            "callBack": _vm.setfirstLogoList
          }
        })];
      },
      proxy: true
    }])
  })], 1)]), _vm.pipsListFullScreen ? _c('div', {
    staticClass: "closeBtn",
    class: {
      hide: _vm.showUploadLogo
    }
  }, [_c('div', {
    staticClass: "common"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showCloseFullScreenBtn,
      expression: "showCloseFullScreenBtn"
    }],
    on: {
      "click": function ($event) {
        _vm.pipsListFullScreen = false;
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-error"
  }), _vm._v(_vm._s(_vm.$t('kioskHost.exitFullScreen')))])]), _c('div', {
    staticClass: "common"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showCloseFullScreenBtn,
      expression: "showCloseFullScreenBtn"
    }],
    on: {
      "click": _vm.controlLogoBox
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(_vm._s(_vm.$t('kioskHost.addBack')))])])]) : _vm._e(), _c('div', {
    staticClass: "commonParty hide"
  }, [_c('NewAttendUser', {
    staticClass: "is-local",
    attrs: {
      "singChannel": _vm.channels[_vm.userInfo.rtilCode],
      "title": "Me",
      "degreeHost": _vm.degreeHost[_vm.userInfo.rtilCode],
      "userInfo": _vm.userInfo
    },
    on: {
      "callback": _vm.operateCallback
    }
  }, [_c('div', {
    staticClass: "localVideo",
    class: _vm.returnVideoClass,
    attrs: {
      "id": "local_stream"
    }
  })])], 1), _c('div', {
    staticClass: "extralParty hide"
  }, [_c('NewAttendUser', {
    staticClass: "is-local",
    attrs: {
      "singChannel": _vm.channels[_vm.userInfo.rtilCode],
      "title": "extralMe",
      "userInfo": _vm.userInfo
    }
  }, [_c('div', {
    staticClass: "localVideo",
    attrs: {
      "id": "local_stream_extral"
    }
  })])], 1), _vm.setTagName.show ? _c('tag-name', {
    attrs: {
      "info": _vm.setTagName
    },
    on: {
      "saveTagName": _vm.saveTagName
    }
  }) : _vm._e(), _c('guide-page', {
    attrs: {
      "dialogVisible": _vm.State.guideObjShow
    }
  }), _vm.dailogInfo.show ? _c('TipsDailog', {
    attrs: {
      "width": "600px",
      "info": _vm.dailogInfo
    },
    on: {
      "save": _vm.dealConfirm
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.dailogText))])]) : _vm._e(), _c('EncoderInfo', {
    attrs: {
      "info": _vm.encoderInfo
    }
  }), _vm.anyWhereInfo.show ? _c('anywhereSetting', {
    attrs: {
      "anyWhereSetObj": _vm.anyWhereSettings[_vm.anyWhereInfo.rtilCode],
      "peerId": _vm.anyWherePeerIds[_vm.anyWhereInfo.rtilCode],
      "platForm": _vm.anyWherePlatForms[_vm.anyWhereInfo.rtilCode],
      "singChannel": _vm.anyWhereVideoAudioInfo,
      "userInfo": _vm.userInfo,
      "info": _vm.anyWhereInfo,
      "partyCode": '' + _vm.partyCode,
      "muteAudio": !_vm.State.micStatus[_vm.anyWhereInfo.rtilCode],
      "rtc": _vm.rtc[_vm.userInfo.realPartyCode]
    },
    on: {
      "closeAnywherePreview": _vm.closeAnywherePreview
    }
  }) : _vm._e(), _vm.movePartyInfo.show ? _c('MovePartyList', {
    attrs: {
      "info": _vm.movePartyInfo,
      "userInfo": _vm.userInfo
    }
  }) : _vm._e(), _vm.batchMovePartyInfo.show ? _c('MovePartyTips', {
    attrs: {
      "info": _vm.batchMovePartyInfo,
      "userInfo": _vm.userInfo
    }
  }) : _vm._e(), _c('Foot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.pipsListFullScreen,
      expression: "!pipsListFullScreen"
    }],
    ref: "footDiv",
    attrs: {
      "isShare": _vm.isShare,
      "mic": _vm.mic,
      "showUnread": _vm.showUnread,
      "rtcLoaded": _vm.rtcLoaded,
      "showIconArray": ['mic', 'speaker', 'multiTypeshare', 'chat'],
      "currentTypeShare": _vm.shareScreenType,
      "devicesInfo": _vm.devicesInfo,
      "userInfo": _vm.userInfo,
      "showChat": _vm.State.showChatMessage,
      "localVolume": _vm.localVolume,
      "rtc": _vm.rtc[_vm.userInfo.realPartyCode],
      "speakerDevice": _vm.devicesInfo.speakerList,
      "microphoneDevice": _vm.devicesInfo.microphoneList,
      "disabled": _vm.outputSourceType == 'Pbp' ? ['shareAsMainwindow'] : [],
      "isHost": true
    },
    on: {
      "eventCallback": _vm.dealFootEvent
    }
  })], 1), _vm.userInfo.rtilCode && _vm.loadChatBox ? _c('div', {
    staticClass: "chatBox"
  }, [_c('ChatMessage', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.State.showChatMessage,
      expression: "State.showChatMessage"
    }],
    attrs: {
      "userInfo": _vm.userInfo,
      "allPartyMembers": _vm.allPartyMembers,
      "chatPartyCode": _vm.userInfo.realPartyCode,
      "showComponent": _vm.State.showChatMessage,
      "nickNameInfo": _vm.behaviorInfo,
      "tagNameInfo": _vm.tagNameInfo
    },
    on: {
      "callback": _vm.chatCallback
    }
  })], 1) : _vm._e(), _c('tipsDailog', {
    staticClass: "collaboratePopup",
    attrs: {
      "info": _vm.collaborateInfo,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        return _vm.controlInvite(true);
      },
      "cancel": function ($event) {
        return _vm.controlInvite(false);
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('img', {
    attrs: {
      "src": "https://dl.tvunetworks.com/static/partyline/image/people.png"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('personalInfo.account')) + " " + _vm._s(_vm.collaborateInfo.info.fromEmail) + " " + _vm._s(_vm.$t('personalInfo.collaboratePopupLike')))])]), _c('div', {
    staticClass: "popupContent"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupAllow')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail1')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail2')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail3')))])])])]), _c('TipsDailog', {
    attrs: {
      "info": _vm.fullScreenTips,
      "showClose": false
    },
    on: {
      "save": _vm.setFullScreen
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('kioskHost.fullScreenAuthText')))])]), _c('tipsDailog', {
    staticClass: "repeatJoin",
    attrs: {
      "width": "550px",
      "info": _vm.repeatInfo
    },
    on: {
      "save": function ($event) {
        _vm.repeatInfo.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.repeatContent')))])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };